import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UtilService {

  public showFooter: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public showHeader: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public showModal: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public modalCloseUrl: BehaviorSubject<string> = new BehaviorSubject<string>("/map");

  constructor() { }

  public toggleModal() {
    this.showModal.next(!this.showModal.value);
  }

}
